"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var componentStyle = {
    base: {
        width: 246,
    },
    icon: {
        margin: '0 14px 0 18px',
    },
};
var description = 'Here you have a placeholder and a icon.';
var code = "import React from 'react';\nimport { FloatingInput } from 'jsc-react-ui';\n\nconst style = {\n  base: {\n    width: 246,\n  },\n  icon: {\n    margin: '0 14px 0 18px',\n  },\n};\n\nconst Example = () => (\n  <FloatingInput\n    style={style.base}\n    placeholder=\"Search\"\n    leftElement={<Icon style={style.icon} name=\"search />\"}\n  />\n);";
exports.IconAndPlaceholderExampleFloatingInput = function () { return (React.createElement(common_1.Example, { title: "Icon and Placeholder", description: description, code: code },
    React.createElement(components_1.FloatingInput, { style: componentStyle.base, placeholder: "Search", leftElement: React.createElement(components_1.Icon, { style: componentStyle.icon, name: "search" }) }))); };
exports.IconAndPlaceholderExampleFloatingInput.displayName = 'IconAndPlaceholderExampleFloatingInput';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentFloatingInputPage/IconAndPlaceholderExampleFloatingInput.tsx
// module id = 675
// module chunks = 0